
const Deferred = {
  promise: null,
  resolve: null
}

export default {
  name: "UnableItemDialog",
  API: ["open"],
  props: {
    showMask: {
      type: Boolean,
      default: true
    },
    disMaskClick: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {},
  watch: {
    visible: {
      handler(newVal, old) {
        if (!newVal) {
          console.log(newVal)
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    open() {
      this.visible = true
      Deferred.promise = new Promise(resolve => {
        Deferred.resolve = resolve
      })
      return Deferred.promise
    },
    close() {
      this.visible = false
    },
    confirm(val) {
      this.visible = false
      Deferred.resolve(val)
    },
    maskClick() {
      if (!this.disMaskClick) {
        this.visible = false
      }
    }
  }
}
